module.exports = __webpack_public_path__ + "assets/img/wolf-attack.33ca0dac.png";